import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, CircularLoader, CloseButton, Column, ConfirmationModal, Row, Typography, useOverlayContext } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { formatFileSize } from '~/utils/fileSize.utils';
export const GetAttachmentsListTID = (parentTestId)=>getTestIds(parentTestId);
export const AttachmentsList = (param)=>{
    let { attachments, onRemove, bi, testId } = param;
    const { t: listTexts } = useLocaleKeys('common.attachments');
    const { t: attachmentFileTexts } = useLocaleKeys('components.attachmentFile');
    const { t: commonTexts } = useLocaleKeys('common');
    const { AttachmentsListTestIds } = useMemo(()=>GetAttachmentsListTID(testId), [
        testId
    ]);
    const overlayContext = useOverlayContext();
    if (attachments.length === 0) return null;
    const confirmRemove = (index, fileName)=>overlayContext.showModal({
            biName: 'bill_modal_attachment_remove_confirm',
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(ConfirmationModal, {
                    bi: {
                        primaryButton: {
                            name: 'bill_modal_attachment_remove_confirm'
                        },
                        secondaryButton: {
                            name: 'bill_modal_attachment_remove_cancel'
                        }
                    },
                    skin: "danger",
                    title: attachmentFileTexts.removeFile(),
                    content: /*#__PURE__*/ _jsxs(Column, {
                        gap: 8,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                align: "left",
                                children: attachmentFileTexts.confirmRemoveContent({
                                    fileName
                                })
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                align: "left",
                                children: attachmentFileTexts.fileNoLongerAccessible()
                            })
                        ]
                    }),
                    primaryButtonLabel: commonTexts.buttons.removeFile(),
                    secondaryButtonLabel: commonTexts.buttons.cancel(),
                    onPrimaryButtonClick: ()=>{
                        onRemove(index);
                        dismissModal();
                    },
                    onSecondaryButtonClick: dismissModal,
                    onCloseButtonClick: dismissModal
                });
            }
        });
    return /*#__PURE__*/ _jsxs(Box, {
        testId: AttachmentsListTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph1",
                weight: "normal",
                testId: AttachmentsListTestIds.Title(),
                children: listTexts.title()
            }),
            /*#__PURE__*/ _jsx(Column, {
                children: attachments.map((file, index)=>/*#__PURE__*/ _jsxs(Row, {
                        gap: 4,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph1",
                                testId: AttachmentsListTestIds.File(file.displayName),
                                children: file.displayName
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                skin: "secondary",
                                variant: "paragraph1",
                                testId: AttachmentsListTestIds.FileSize(file.displayName),
                                children: "(".concat(formatFileSize(file.fileSize), ")")
                            }),
                            file.loading ? /*#__PURE__*/ _jsx(CircularLoader, {
                                size: 16,
                                testId: AttachmentsListTestIds.FileLoader(index)
                            }) : /*#__PURE__*/ _jsx(CloseButton, {
                                bi: bi.removeFile,
                                skin: "transparent",
                                size: "small",
                                testId: AttachmentsListTestIds.RemoveButton(index),
                                onClick: ()=>confirmRemove(index, file.displayName)
                            })
                        ]
                    }, file.id))
            })
        ]
    });
};
